"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_QUOTE = void 0;
var _initialPet = require("./initialPet");
var _initialOwner = require("./initialOwner");
var INITIAL_QUOTE = exports.INITIAL_QUOTE = {
  pets: [_initialPet.INITIAL_PET],
  owner: _initialOwner.INITIAL_OWNER,
  onlineQuoteNumber: 0,
  onlineNumber: 0,
  quoteReferenceNumber: null,
  appId: null,
  westpac: null,
  totalPremium: 0,
  lessFreeMonthAmount: 0,
  totalAnnualAmount: 0,
  totalAnnualFreeMonthAmount: 0,
  paymentStartDate: null,
  policyStartDateId: 0,
  policyStartDate: null,
  isReferToUnderwriter: null,
  isAcceptTandC: null,
  applicationSubmitted: false,
  isNew: true,
  currentPetNumber: 0,
  paymentFrequency: null,
  paymentFrequencyCode: null,
  promotionCode: null,
  hasPromotionCode: null,
  promotionNo: 0,
  hasValidPromotion: null,
  promotionMessage: null,
  memberNumber: null,
  staffMemberNumber: null,
  crnNumber: null,
  hasValidMemberNumber: null,
  isValidCardHolder: null,
  promotionEffectiveFrom: null,
  promotionEffectiveTo: null,
  hasMemberNumber: false,
  hasStaffMemberNumber: null,
  selectedMediaListCode: null,
  selectedMediaListName: null,
  hasMediaList: null,
  isEFulfillment: true,
  hasRegularVet: null,
  regularVet: null,
  regularVetCode: null,
  staffId: null,
  hasPensionerNumber: null,
  pensionerNumber: null,
  paymentMethodCode: null,
  officeCode: null,
  brokerNumber: null,
  reimbursementInfo: null,
  stage: null,
  siteType: null,
  channel: null,
  telephone: false,
  faceToFace: false,
  web: true,
  externalId: null,
  productCodes: null,
  excesses: null,
  levelOfCovers: null,
  annualBenefitLimits: null,
  fixedTerms: null,
  paymentFrequencies: null,
  partners: [],
  selectedPartner: null,
  partnerSequence: null,
  partnerKey: null,
  hasZeroPremium: false,
  hubspotUserToken: null,
  pageUri: null,
  lcoConsentToProcess: null,
  lcoConsentText: null,
  lcoCommSubTypeId: null,
  lcoCommText: null,
  retrieveQuoteUrl: null,
  retrieveCode: null
};